const configModule = {
    namespaced: true,//开启命名空间 
    state: () => ({

    }),
    mutations: {
        //修改模块中的状态   页面调用(this as any).$store.commit('config/setTest',3)
        // setTest(state, test) {
        //     state.test = test;
        // }
    },
    actions: {},
    getters: {}
}
export default configModule